// 利用設定の項目定義（キーと範囲はサーバー側 services/admin_ops.py の OPS_CONFIG_RANGES と同期させること）
export const OPS_CONFIG_FIELDS = [
    // { key: "talk_limit", label: "会話回数上限", type: "int", min: 0, max: 100000000, unit: "回", usageKey: "talk_count",
    //     desc: "対話画面・Playground の会話回数の上限です。\n到達すると応答を停止します。" },
    // { key: "evaluation_limit", label: "RAG応答テスト回数上限", type: "int", min: 0, max: 100000000, unit: "回", usageKey: "evaluation_count",
    //     desc: "RAG応答テストの実行回数の上限です。" },
    { key: "use_adjust_question", label: "質問補強", type: "bool",
        desc: "検索の前に、会話の流れを踏まえて質問文を補います。\nOFFの場合は共感メッセージのプロンプトは使用されません。" },
    { key: "use_rag", label: "RAG検索", type: "bool",
        desc: "登録した RAG ファイルを検索し、回答の根拠に使います。\nOFFの場合は RAG Fusion・検索件数も使われません。" },
    { key: "use_rag_fusion", label: "RAG Fusion", type: "bool",
        desc: "質問を複数の言い換えで検索し、結果を統合して順位付けします。\nRAG検索がONの場合のみ有効です。" },
    { key: "search_count", label: "検索件数", type: "int", min: 1, max: 20, unit: "件",
        desc: "回答の根拠にする検索結果の上位件数です（1〜20）。\nRAG検索がONの場合のみ有効です。" },
    { key: "use_upload_user_prompt", label: "ユーザープロンプトのアップロード", type: "bool",
        desc: "ONにすると、RAGファイル管理に「追加参照ファイル」が表示され、最終返答のユーザープロンプトをファイルで差し替え・ダウンロードできるようになります。\nプロンプト管理での編集はON/OFFに関係なく行えます。" },
];

const toNumber = (value) => (value === "" || value === null || value === undefined ? NaN : Number(value));
const formatNumber = (n) => Number(n).toLocaleString("ja-JP");

/** 編集中の値（draft に無ければ保存済みの値） */
export const configValue = (saved, draft, key) => (key in draft ? draft[key] : saved?.[key]);

/** 数値項目の入力エラー（無ければ空文字） */
export const fieldError = (field, value) => {
    if (field.type !== "int") return "";
    const n = toNumber(value);
    if (!Number.isInteger(n)) return "整数を入力してください";
    if (n < field.min || n > field.max) return `${formatNumber(field.min)}〜${formatNumber(field.max)} の範囲で入力してください`;
    return "";
};

/** 上限を現在の利用回数以下にしたときの警告（保存は可能） */
export const usageWarning = (field, value, used) => {
    if (!field.usageKey || fieldError(field, value)) return "";
    return toNumber(value) <= used ? "現在の利用回数以下のため、保存直後から上限到達として扱われます" : "";
};

const typedValue = (field, value) => (field.type === "int" ? toNumber(value) : value);

/** 保存する変更（項目定義順。入力エラーの項目は含めない） */
export const buildConfigChanges = (saved, draft) => {
    if (!saved) return [];
    return OPS_CONFIG_FIELDS
        .filter((field) => field.key in draft && !fieldError(field, draft[field.key]))
        .map((field) => ({ field, before: saved[field.key], after: typedValue(field, draft[field.key]) }))
        .filter((change) => change.before !== change.after);
};

export const configErrorCount = (saved, draft) => (
    OPS_CONFIG_FIELDS.filter((field) => fieldError(field, configValue(saved, draft, field.key))).length
);

export const canSaveConfig = (saved, draft) => (
    !!saved && configErrorCount(saved, draft) === 0 && buildConfigChanges(saved, draft).length > 0
);

export const formatConfigValue = (field, value) => (
    field.type === "int" ? `${formatNumber(value)} ${field.unit}` : (value ? "ON" : "OFF")
);

/** 更新APIに送るパラメータ（変更したキーだけ） */
export const configUpdateParams = (changes) => Object.fromEntries(changes.map((change) => [change.field.key, change.after]));
